// NAT HOF — Product SKU Migration Map
// Source: Loja Integrada → Shopify migration
// Purpose: Used by reviewsService to resolve the correct SKU
// when fetching reviews from Konfidency during/after migration.

export interface ProductSKUEntry {
  shopifyId: string;
  lojaIntegradaId: string;
  handle: string;
  name: string;
  reviewCount: number;
  reviewsKonfidencyId: string;
}

export const PRODUCTS_SKU_MAP: ProductSKUEntry[] = [
  {
    shopifyId: '8277846687931',
    lojaIntegradaId: '262968254',
    handle: 'hidratante-corporal-dermoconstrutor-80g',
    name: 'Hidratante Corporal Dermoconstrutor 80g',
    reviewCount: 22,
    reviewsKonfidencyId: '8277846687931',
  },
  {
    shopifyId: '8277850161339',
    lojaIntegradaId: '266467644',
    handle: 'hidratante-para-os-pes-dermoconstrutor-80g',
    name: 'Hidratante para os Pés Dermoconstrutor 80g',
    reviewCount: 18,
    reviewsKonfidencyId: '8277850161339',
  },
  {
    shopifyId: '8277849145531',
    lojaIntegradaId: '266467886',
    handle: 'hidratante-para-as-maos-dermoconstrutor-80g',
    name: 'Hidratante para as Mãos Dermoconstrutor 80g',
    reviewCount: 21,
    reviewsKonfidencyId: '8277849145531',
  },
  {
    shopifyId: '8277846196411',
    lojaIntegradaId: '266503218',
    handle: 'hidratante-corporal-dermoconstrutor-1000g',
    name: 'Hidratante Corporal Dermoconstrutor 1000g',
    reviewCount: 22,
    reviewsKonfidencyId: '8277846196411',
  },
  {
    shopifyId: '8277850554555',
    lojaIntegradaId: '266503660',
    handle: 'balsamo-hidratante-ozonizado-com-blend-de-oleos-essenciais-30ml',
    name: 'Bálsamo Hidratante Ozonizado com Blend de Óleos Essenciais 30ml',
    reviewCount: 32,
    reviewsKonfidencyId: '8277850554555',
  },
  {
    shopifyId: '8277850751163',
    lojaIntegradaId: '308697855',
    handle: 'sabonete-liquido-extra-suave-150ml',
    name: 'Sabonete Líquido Extra Suave 150ml',
    reviewCount: 28,
    reviewsKonfidencyId: '8277850751163',
  },
  {
    shopifyId: '8310558359739',
    lojaIntegradaId: '316338806',
    handle: 'necessaire-exclusiva-bordada',
    name: 'Necessaire Exclusiva Bordada',
    reviewCount: 1,
    reviewsKonfidencyId: '8310558359739',
  },
  {
    shopifyId: '8316874719419',
    lojaIntegradaId: '316339130',
    handle: 'kit-hidratacao-diaria-essencial',
    name: 'Kit Hidratação Diária Essencial',
    reviewCount: 5,
    reviewsKonfidencyId: '8316874719419',
  },
  {
    shopifyId: '8316873638075',
    lojaIntegradaId: '316339137',
    handle: 'kit-hidratacao-e-limpeza-suave',
    name: 'Kit Hidratação e Limpeza Suave',
    reviewCount: 17,
    reviewsKonfidencyId: '8316873638075',
  },
  {
    shopifyId: '8316872949947',
    lojaIntegradaId: '316339142',
    handle: 'kit-regeneracao-e-hidratacao-intensiva',
    name: 'Kit Regeneração e Hidratação Intensiva',
    reviewCount: 29,
    reviewsKonfidencyId: '8316872949947',
  },
];

export const getProductByHandle = (handle: string): ProductSKUEntry | undefined =>
  PRODUCTS_SKU_MAP.find(p => p.handle === handle);

export const getProductByShopifyId = (shopifyId: string): ProductSKUEntry | undefined =>
  PRODUCTS_SKU_MAP.find(p => p.shopifyId === shopifyId);

export const getKonfidencyId = (handle: string): string | undefined =>
  PRODUCTS_SKU_MAP.find(p => p.handle === handle)?.reviewsKonfidencyId;

export const ALL_KONFIDENCY_SKUS: string[] =
  PRODUCTS_SKU_MAP.map(p => p.reviewsKonfidencyId);

export const PRODUCTS_BY_REVIEW_VOLUME: ProductSKUEntry[] =
  [...PRODUCTS_SKU_MAP].sort((a, b) => b.reviewCount - a.reviewCount);
